import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import Config from "../Config.json";
import { Link, useParams, useLocation } from "react-router-dom";
import emailjs from "emailjs-com";

import { useTranslation } from "react-i18next";
import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import AOS from "aos";
import "aos/dist/aos.css";

import WaviyText from "../components/WaviyText";

const TITLE = Config.SITE_TITLE + " | Home";
const DESC =
  "This is a website application about the use of AI in everyday life.";

const Home = ({ category }) => {
  const formRef = useRef();
  const [message, setMessage] = useState("");
  const [messageClass, setMessageClass] = useState("hidden");
  const [email, setEmail] = useState("");
  const { lng } = useParams(); // URL-ből jövő nyelvi paraméter
  const { i18n, t } = useTranslation();
  const location = useLocation();

  // Ha nincs lng a params-ból, akkor az URL első szegmensét használjuk
  const lang = lng || location.pathname.split("/")[1] || i18n.language;

  // Nyelv váltása, ha szükséges
  useEffect(() => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  const categoryRoutes = {
    1: "AITrend",
    2: "MachineLearning",
    3: "AiTools",
    4: "AiGames",
  };

  useEffect(() => {
    // Google Adsense és Bootstrap Carousel script
    const adsScript = document.createElement("script");
    adsScript.async = true;
    adsScript.src =
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
    adsScript.setAttribute("data-ad-client", "ca-pub-YOUR-ADSENSE-ID");
    document.head.appendChild(adsScript);

    const bootstrapScript = document.createElement("script");
    bootstrapScript.src =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js";
    document.body.appendChild(bootstrapScript);

    bootstrapScript.onload = () => {
      const carouselElement = document.querySelector("#carouselExampleDark");
      if (carouselElement) {
        new window.bootstrap.Carousel(carouselElement, {
          interval: 5000,
          ride: "carousel",
        });
      }
    };

    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  useEffect(() => {
    const scrollProgress = document.getElementById("TopBtn");

    const calcScrollValue = () => {
      const pos = document.documentElement.scrollTop;
      const calcHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scrollValue = Math.round((pos * 100) / calcHeight);

      if (pos > 100) {
        scrollProgress.style.display = "grid";
      } else {
        scrollProgress.style.display = "none";
      }

      scrollProgress.style.background = `conic-gradient(#ffb6c1 ${scrollValue}%, #f7f7f7 ${scrollValue}%)`;
    };

    window.addEventListener("scroll", calcScrollValue);
    window.addEventListener("load", calcScrollValue);

    return () => {
      window.removeEventListener("scroll", calcScrollValue);
      window.removeEventListener("load", calcScrollValue);
    };
  }, []);

  const carouselStyle = {
    width: "100%",
    padding: 0,
    margin: 0,
  };

  const imageStyle = {
    width: "100%",
    height: "auto",
    objectFit: "cover",
  };

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formRef.current,
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then(
        (result) => {
          setMessage(t("Thank you for subscribing!"));
          setMessageClass("success");
          setEmail("");
        },
        (error) => {
          setMessage(t("There was an error signing up."));
          setMessageClass("error");
        }
      );
  };

  return (
    <main className="main-content">
      <Helmet>
        <title>
          Csillag Masszázs Pedikűr | Masszázs és Gyógypedikűr Budapesten
        </title>
        <meta
          name="description"
          content="Masszázs és pedikűr modern technológiával Budapesten. Szalonban és kiszállással is elérhető, egészségközpontú szemlélettel."
        />
        <link rel="canonical" href="https://janoseszter.com/hu" />

        <meta
          property="og:title"
          content="Csillag Masszázs Pedikűr | Főoldal"
        />
        <meta
          property="og:description"
          content="Masszázs és gyógypedikűr Budapesten, modern technológiával és szakértelemmel. Szalonban vagy háznál."
        />
        <meta property="og:url" content="https://janoseszter.com/hu" />
        <meta
          property="og:image"
          content="https://janoseszter.com/images/logo225.png"
        />
        <meta property="og:site_name" content="janoseszter.com" />
        <meta property="og:type" content="website" />
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1684163547956689"
          crossorigin="anonymous"
        ></script>
        {/* Schema.org adat */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "HealthAndBeautyBusiness",
              "name": "Csillag Masszázs Pedikűr",
              "url": "https://janoseszter.com",
              "logo": "https://janoseszter.com/images/logo225.png",
              "description": "Masszázs, gyógypedikűr, tanácsadás – személyre szabott gondoskodás Budapesten.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Budapest",
                "addressCountry": "HU"
              },
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+36 70 554 1606",
                "contactType": "customer service"
              }
            }
          `}
        </script>
      </Helmet>
      {/* Hero szekció */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Csillag Masszázs Pedikűr</h1>
            {/*<WaviyText text="Lábápolás" />*/}
            <h2>
              {t("Massage")} | {t("Pedicure")} | {t("Consulting")}
            </h2>

            <Link to={`/${lang}/TimeSlotTable`}>
              <button className="cta-button">{t("Booking")}</button>
            </Link>
          </div>
        </div>
      </section>

      {/* Cookie Consent Modal */}
      <div id="cookieModal" className="cookie-modal">
        <div className="cookie-modal-content">
          <h3>{t("The site uses cookies")}</h3>
          <p>
            {t(
              "Our website uses cookies to improve the user experience. Please accept cookies for the full user experience."
            )}
          </p>
          <div className="cookie-buttons">
            <button id="acceptCookies" className="btn btn-primary">
              {t("I accept it")}
            </button>
            <button id="rejectCookies" className="btn btn-secondary">
              {t("I refuse")}
            </button>
          </div>
        </div>
      </div>
      <button
        id="TopBtn"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <div id="TopBtn-value" aria-label="Go to top">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.59 5.58L20 12l-8-8-8 8z" />
          </svg>
        </div>
      </button>

      <div className="container-fluid mt-1">
        <div className="row">
          <div className="col-lg-12">
            <section className="latest-posts">
              <h2>
                <b>{t("Cim")}</b>
              </h2>
              <div className="row">
                <div className="col-12 col-md-7 mb-4 mb-md-0">
                  <Carousel
                    interval={5000}
                    controls
                    indicators
                    style={carouselStyle}
                  >
                    <Carousel.Item>
                      <a href="LearningEn/#ML03">
                        <img
                          src="/carouselimages/CarouselImages1.png"
                          className="d-block w-100 lazy-load"
                          alt="Svéd masszázs Budapesten – relaxációs kezelés otthon és szalonban"
                          loading="lazy"
                          style={imageStyle}
                        />
                      </a>
                      <Carousel.Caption className="crscolor1">
                        {/* Tartalom opcionális */}
                      </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <a href="LearningEn/#ML07">
                        <img
                          src="/carouselimages/CarouselImages2.png"
                          className="d-block w-100 lazy-load"
                          alt="Irodai Masszázs"
                          loading="lazy"
                          style={imageStyle}
                        />
                      </a>
                      <Carousel.Caption className="crscolor2">
                        {/* Tartalom opcionális */}
                      </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <a
                        href="https://lightning.ai/?utm_term=ai%20development&utm_campaign=General+platform&utm_source=adwords&utm_medium=ppc&hsa_acc=1332059986&hsa_cam=21385925027&hsa_grp=164148004792&hsa_ad=702882092130&hsa_src=g&hsa_tgt=kwd-296920401310&hsa_kw=ai%20development&hsa_mt=b&hsa_net=adwords&hsa_ver=3&gad_source=1&gclid=EAIaIQobChMI6oqi8-ONigMV25aDBx3TcwcIEAAYASAAEgJTnvD_BwE"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/carouselimages/CarouselImages3.png"
                          className="d-block w-100 lazy-load"
                          alt="Gyógypedikűr"
                          loading="lazy"
                          style={imageStyle}
                        />
                      </a>
                      <Carousel.Caption className="crscolor3">
                        {/* Tartalom opcionális */}
                      </Carousel.Caption>
                    </Carousel.Item>
                  </Carousel>
                </div>
                <div className="col-12 col-md-5">
                  <h3>
                    <strong>
                      „Szépség. Harmónia. Kényeztetés – testnek és léleknek.”
                    </strong>
                  </h3>
                  <p>
                    Üdvözlöm a Delice Éden világában, ahol a nyugalom és a
                    professzionális gondoskodás találkozik! Legyen szó a szalon
                    meghitt hangulatáról vagy az Ön otthonának kényelméről,
                    személyre szabott masszázs- és gyógypedikűr
                    szolgáltatásaimmal várom Önt.{" "}
                  </p>{" "}
                  <p>
                    {" "}
                    A svédmasszázstól a tradicionális thai jógamasszázson át a
                    menedzsermasszázsig, valamint gyógyító pedikűrrel és
                    tanácsadással segítem testi-lelki feltöltődését. Minden
                    kezelésem célja, hogy ne csak szebbnek, hanem
                    energikusabbnak és kiegyensúlyozottabbnak is érezze magát.{" "}
                  </p>{" "}
                  <p>
                    {" "}
                    Lépjen be a Delice Édenbe, és tapasztalja meg, milyen az
                    igazi, Önre szabott törődés. Szeretettel várom!
                  </p>
                  <Link to={`/${lang}/About`}>
                    <button className="cta-button">{t("About")}</button>
                  </Link>
                </div>
              </div>

              {/* Szolgáltatások szekció – kártyás formában, mobiloptimalizálva */}
              <section id="szolg" className="szolg">
                <h2>{t("Services")}</h2>
                <div className="szolg-grid">
                  <Link
                    to={`/${lang}/services#gyogypedikur`}
                    className="szolg-link"
                  >
                    <div className="szolg-card" id="card1">
                      <h3>{t("Pedicure")}</h3>
                    </div>
                  </Link>
                  <Link
                    to={`/${lang}/services#masszazs`}
                    className="szolg-link"
                  >
                    <div className="szolg-card" id="card2">
                      <h3>{t("Massage")}</h3>
                    </div>
                  </Link>
                  <Link
                    to={`/${lang}/services#tanacsadas`}
                    className="szolg-link"
                  >
                    <div className="szolg-card" id="card3">
                      <h3>{t("Consulting")}</h3>
                    </div>
                  </Link>
                </div>
              </section>
            </section>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Home;
